const getDefaultState = () => ({
  externalPayment: null,
  hideBilling: null,
  savedCard: null,
  paymentCardType: null,
});

export default {
  namespaced: true,
  state: () => getDefaultState(),
  actions: {
    externalPayment({ commit }, payload) {
      commit("externalPayment", payload);
    },
    savedCard({ commit }, payload) {
      commit("savedCard", payload);
    },
    paymentCardType({ commit }, payload) {
      // FIXME: ideally shouldn't be needing this action.
      // see if we can safely remove
      commit("paymentCardType", payload);
    },
    resetState({ commit }) {
      commit("resetState");
    },
  },
  mutations: {
    externalPayment(state, payload) {
      state.externalPayment = payload;
    },
    savedCard(state, payload) {
      state.savedCard = payload;
    },
    paymentCardType(state, payload) {
      state.paymentCardType = payload;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  },
  getters: {
    externalPayment: state => state.externalPayment,
    paymentRoutingInfo(state, getters, rootState, rootGetters) {
      return {
        externalPayment: getters.externalPayment,
        hideBilling: getters.hideBilling,
        trials: rootGetters.trials,
        view: rootGetters.view,
      };
    },
    hideBilling(state, getters, rootState) {
      return rootState.partnerInfo?.flags?.hideBillingPageOnPaymentViaPartner || false;
    },
    savedCard: state => state.savedCard,
    paymentCardType: (state, getters) => state.paymentCardType || getters.savedCard?.funding,
  },
};
